module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main